import { Menu } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function Header({ onMenuClick, title }) {
  const { user } = useAuth();

  return (
    <header data-testid="header" className="sticky top-0 z-30 h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        <button
          data-testid="menu-toggle"
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-slate-100 text-slate-600 transition-colors"
        >
          <Menu className="h-5 w-5" />
        </button>
        <h1 className="text-xl font-semibold text-slate-900 font-['Outfit']">{title}</h1>
      </div>
      <div className="flex items-center gap-3">
        <span className="hidden sm:inline text-sm text-slate-600">{user?.email}</span>
        <div className="h-8 w-8 rounded-full bg-blue-700 flex items-center justify-center text-sm font-medium text-white">
          {user?.picture ? (
            <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover" />
          ) : (
            user?.name?.[0]?.toUpperCase() || 'U'
          )}
        </div>
      </div>
    </header>
  );
}
